import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    standalone: false,
    templateUrl: "./temperatureInput.component.html",
})
export class FormlyTemperatureInput extends FieldType<FieldTypeConfig> {}
